"use client";
import { useState, type PropsWithChildren } from "react";
import { CornerLayer } from "./corner-context";
import s from "./corners.module.css";

/** Corner stacks wrap when expanding controls would otherwise overlap. */
export function CornersProvider({ children }: PropsWithChildren) {
  const [layer, setLayer] = useState<HTMLDivElement | null>(null);
  return (
    <CornerLayer value={layer}>
      {children}
      <div ref={setLayer} className={s.layer} data-site-corners="">
        <div className={s.band} data-band="top">
          <div className={s.stack} data-corner="top-left" />
          <div className={s.stack} data-corner="top-right" />
        </div>
        <div className={s.band} data-band="bottom">
          <div className={s.stack} data-corner="bottom-right" />
          <div className={s.stack} data-corner="bottom-left" />
        </div>
      </div>
    </CornerLayer>
  );
}
